var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0412 8.48063C11.0412 9.29836 10.3325 9.96126 9.45812 9.96126C8.58379 9.96126 7.875 9.29836 7.875 8.48063C7.875 7.6629 8.58379 7 9.45812 7C10.3325 7 11.0412 7.6629 11.0412 8.48063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09149 11.0496H10.7977V19.25H8.09149V11.0496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1546 11.0496H12.4485V19.25H15.1546C15.1546 19.25 15.1546 16.6684 15.1546 15.0542C15.1546 14.0854 15.4854 13.1123 16.8054 13.1123C18.2971 13.1123 18.2882 14.3802 18.2812 15.3625C18.2721 16.6464 18.2938 17.9566 18.2938 19.25H21V14.922C20.9771 12.1585 20.257 10.8851 17.8879 10.8851C16.481 10.8851 15.6089 11.5238 15.1546 12.1017V11.0496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.71d5e557d339297fae6b1a1678d3a54a.svg";
export { ForwardRef as ReactComponent };